module.exports = __webpack_public_path__ + "static/img/pousse-porte.dc06241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/pousse-porte.jpg
// module id = lx/l
// module chunks = 0